<template>
  <div
    :key="key"
    :class="{ required: data.required, disabled: data.disabled }"
    class="field">
    <label>{{ $t(data.label) }}</label>
    <select
      v-model="input"
      class="ui fluid dropdown"
      :name="data.hasOwnProperty('name') ? data.name : `select-input-${_uid}`"
      :multiple="data.multiple">
      <option :value="null">{{ $t(data.placeholder) }}</option>
      <option
        v-for="option in data.options"
        :key="option.value"
        :value="option.value">
        {{ option.hasOwnProperty('untranslated') ? option.untranslated : $t(option.label) }}
      </option>
    </select>
  </div>
</template>

<script>

export default {
  name: 'DropdownInput',
  props: {
    data: {
      type: Object,
      required: true
    },
    value: {
      required: true
    }
  },
  data () {
    return {
      input: this.value
    }
  },
  created () {
    if (this.data.multiple) {
      if (!Array.isArray(this.input)) {
        this.input = []
      }
    }
  },
  mounted () {
    $('.ui.dropdown').dropdown()
  },
  computed: {
    key () {
      return `dropdown-${this.$i18n.locale}`
    }
  },
  watch: {
    input: {
      handler: function (value) {
        this.$emit('input', this.input)
      },
      deep: true
    },
    '$i18n.locale' () {
      $('.ui.dropdown').dropdown()
    }
  }
}
</script>

<style scoped>

</style>
